import api from "./../service/apiService";
import { apiUrl } from "./../constants/apiUrl";
import { logKafka } from "./../service/logService";
import { InHomeUtils } from './../util/inhomeUtils';
import {TVUSOCS } from './../constants/actionType'
import { store } from "../../src/index" /**importing store for reducer values */

// Get lfaname
export const getLFA = (visitId, visitorId, tarcode, zip, appId,customonly, dispatch, isChangeFlow = false, csrTVPkg = "", isFCPFlow = false) => {
  let url = apiUrl().channelLineupVhoUrl;
  api(url, "POST", getVhoDetails(visitId, visitorId, tarcode, zip, appId))
    .then(response => {
      const vhoList = response.vhoregionlist;
      if (response.vhoregionlist.length > 1) {
        dispatch({ type: "ZIPCHANGE", value: { vhoList: vhoList, loading: true, multiple: true } });
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
      } else {
        dispatch({ type: "ZIPCHANGE", value: { vhoList: vhoList, loading: true, multiple: false } });
      }
      getPackages(visitId, visitorId, "NC", vhoList[0].lfa, csrTVPkg , vhoList[0].vhoname, customonly, dispatch, isFCPFlow);
    })
    .catch(error => {
      let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
      let errorMsg = `MethodName:getLFA,errorMessage:${error.message}`;
      logKafka("ERROR","ChannelLineUp",errorMsg,getErrorLogUrl,"applogs",visitId);
    });
};

export const countySelected = (countySelected, dispatch) => {
  dispatch({ type: "COUNTYSELECTED", value: countySelected, multiple: false });
};
// Get list of packages for a LFA
export const getPackages = (visitid, visitorid, appid, lfa, csrpackage, vhoname, customonly, dispatch, isFCPFlow = false) => {

  // Clear the selected packages, if any
  clearSelectedChannels(dispatch);
  clearSelectedPkgs(dispatch);
  let fcppakcageids="Q6457,Q6456,Q7818,Q9599,Q6454";

  let url = apiUrl().channelLineupPackagesUrl;
  let request = { visitid: visitid.toString(), visitorid: visitorid.toString(), appid: appid.toString(), lfa: lfa.toString(), csrpackage: csrpackage.toString(), vhoname: vhoname.toString() };
  api(url, "POST", JSON.stringify(request))
    .then(response => {
      var packageList = response.masterpackagesview;
      let packageListCustom = [];
      let packageListNew= [];
      var pkgs = packageList.map(pkg => {
        var name = pkg.packagename.replace(/&amp;/g, "&");
        pkg.name = name;
        if(name.indexOf("Custom")!==-1) {
            packageListCustom.push(pkg);
        }
        if (isFCPFlow) {
          if (fcppakcageids.indexOf(pkg.packageusoc) > -1) {
            packageListNew.push(pkg);
          }
        }
        else {
          if (fcppakcageids.indexOf(pkg.packageusoc) == -1) {
            packageListNew.push(pkg);
          }
        }

        return { ...pkg, packagename: name };      
      });
      
      if (customonly === 'Y') {
        dispatch({ type: "SETPACKAGES", value: { packageList: packageListCustom } });
      }
      else {
        dispatch({ type: "SETPACKAGES", value: { packageList: packageListNew } });
      }
      dispatch({ type: "CLUMESSAGE", value: "" });
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    })
    .catch(error => {
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
      let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
      let errorMsg = `MethodName:getPackages,errorMessage:${error.message}`;
      logKafka("ERROR","ChannelLineUp",errorMsg,getErrorLogUrl,"applogs",visitid);      
    });
};

// Get list of channels or programs based on input
export const getChannels = (visitid, visitorid, lfa, appid, programchannelname, dispatch) => {
  dispatch({ type: "SEARCHANNELTEXT", value: programchannelname });

  if (programchannelname === "") return;

  let url = apiUrl().channelProgramMasterUrl;
  let request = { visitid: visitid.toString(), visitorid: visitorid.toString(), lfa: lfa.toString(), appid: appid.toString(), programchannelname: programchannelname.toString() };
  api(url, "POST", JSON.stringify(request))
    .then(response => {
      let searchDropdown = response.chanelprogramlist;
      dispatch({ type: "SETSEARCHDROPDOWN", value: { searchDropdown: searchDropdown } });
    })
    .catch(error => {
      let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
      let errorMsg = `MethodName:getChannels,errorMessage:${error.message}`;
      logKafka("ERROR","ChannelLineUp",errorMsg,getErrorLogUrl,"applogs",visitid);
    });
};

// Get package results based on program or channel selection
export const getChannelResults = (visitid, visitorid, lfa, vhoname, elkchannelprogram, name, channelid, type, programid, appid, selected, pkgs, dispatch) => {
  let url = apiUrl().channelProgramSearchUrl;
  if (name === "") return;

  let request = {
    visitid: visitid.toString(), visitorid: visitorid.toString(), lfa: lfa.toString(), vhoname: vhoname.toString(),
    elkchannelprogram: elkchannelprogram.toString(), name: name.toString(), channelid: channelid.toString(), type: type.toString(),
    programid: programid.toString(), appid: appid.toString()
  };

  api(url, "POST", JSON.stringify(request))
    .then(response => {
      let channelProgramResults = response.channellistwithpack;
      dispatch({ type: "SETCHANNELPROGRAMRESULTS", value: { channelProgramResults: channelProgramResults } });
      return channelProgramResults;
    })
    .then(channelProgramResults => {
      // selectedChannelPrograms
      if (channelProgramResults.length > 0) {
        let selectedChannelPrograms = [];
        if (selected) {
          selectedChannelPrograms = [...selected];
        }
        selectedChannelPrograms.push(channelProgramResults[0]);
        dispatch({ type: "SETSELECTEDCHANNELPROGRAMS", value: selectedChannelPrograms });
        dispatch({ type: "CLUMESSAGE", value: "Select 2 TV plans to compare." });

        sortPackages(pkgs, selectedChannelPrograms, dispatch);
      } else {
        dispatch({ type: "CLUMESSAGE", value: "Sorry, channel or program you searched for is not available." });
      }
    })
    .catch(error => {
      let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
      let errorMsg = `MethodName:getChannelResults,errorMessage:${error.message}`;
      logKafka("ERROR","ChannelLineUp",errorMsg,getErrorLogUrl,"applogs",visitid);
    });
};

export const getChannelLineupbackend = (visitId, visitorid, tarcode, zipcode, packageid, dispatch) => {
  let url = apiUrl().channelLineupPackageView;
  const comparePackages = [];
  let allChannels = [];
  let packageIdCheck;
  let buildProduct = store.getState().buildProduct
  let runtimekey = store.getState().loopQual.runtimeKey
  let tvnewusocs = runtimekey?.newMMTVUsocs.split(",") || []
  let isClassicAccount = buildProduct.isClassicAccount
  let fcpFlow = InHomeUtils.isFcpFlow();
  /**as compare plans packageid lists are coming as an array with correct id we dont need to chnage it
   *  and handling if the packageid already belongs oldUSocs handling the error cases classic case added */
  if(!Array.isArray(packageid) && fcpFlow){
    if(!TVUSOCS.oldUsocs.includes(packageid)){
      let newindx  = TVUSOCS.newUsocs.indexOf(packageid);
      if(newindx > -1) {
      packageid = TVUSOCS.oldUsocs[newindx]
      }
      else{
        let indx = TVUSOCS.newTVUsocs.indexOf(packageid);
        if(indx > -1){
          packageid = TVUSOCS.oldUsocs[indx]
        }
        else{
          let indx = TVUSOCS.newMMTVUsocs.indexOf(packageid);
        if(indx > -1){
          packageid = TVUSOCS.oldUsocs[indx]
        }
        }
         indx = tvnewusocs.indexOf(packageid);
         if(indx > -1){
          packageid = TVUSOCS.oldUsocs[indx]
        }
       }
    } 
  }

  // for (let dmacount = 0; dmacount < buffalozips.length; dmacount++) {
  //   if (buffalozips[dmacount] === parseInt(lqState.selectedAdr.zip)) {
  //     dispatch({ type: CheckLQ.isBuffalloDMA, value: true })
  //   }
  // }
  if (typeof packageid === "string") {
    packageIdCheck = [packageid];
  } else {
    packageIdCheck = packageid;
  }

  //for (let id of packageIdCheck) {
    for (let i = 0; i < packageIdCheck.length; i++) {
      api(url, "POST", getRequestChannelView(visitId, visitorid, tarcode, zipcode, packageIdCheck[i]))
      .then(response => {       
        const channelList = response.channesnameview[0].channelist;
        const numChannels = response.channesnameview[0].totalchannelcount;
        const hdChannels = response.channesnameview[0].hdchannelcount;
        var name = response.channesnameview[0].packgename;

        if(name == null){
          name='';
        }

        const title = name.replace(/&amp;/g, "&");
        const location = response.channesnameview[0].lfaname;
        let newGenreList = [];
        channelList.forEach(channel => {
          if (!newGenreList.includes(channel.genrelist)) {
            newGenreList.push(channel.genrelist);
          }
        });
        const channelHeadings = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];
        channelList.sort(function(a, b) {
          if (a.channelname.toUpperCase() < b.channelname.toUpperCase()) {
            return -1;
          } else {
            return 1;
          }
        });
        //console.log('channelHeadings' + channelHeadings);    
        
       // allChannels = [...allChannels, ...channelList];
        allChannels = allChannels.concat(channelList);
        allChannels.sort(function(a, b) {  
          if (a.channelname.toUpperCase() < b.channelname.toUpperCase()) {
            return -1;
          } else {
            return 1;
          }
        });
        
        let stringAllChannels = allChannels.map(channel =>
          JSON.stringify(channel)
        );
        let uniq = [...new Set(stringAllChannels)];
        allChannels = uniq.map(channel => JSON.parse(channel));
        let results = [];
        let index = 0;
        channelHeadings.forEach(function(value) {
          results.push(value);
          var containsChannels = false;
          for (var i = index; i < allChannels.length; i++) {
            if (allChannels[i].channelname[0].toUpperCase() === value) {
              results.push(allChannels[i]);
              containsChannels = true;
            } else {
              index = i++;
              break;
            }
          }
          if (!containsChannels) {
            results.pop();
          }
        });
        
        const pkg = {
          packageid: packageIdCheck[i], genreList: newGenreList.sort(), numChannels: numChannels,
          hdChannels: hdChannels, channels: channelList, results: results, title: title, location: location, active: "alpha", loaded: true
        };

        comparePackages.push(pkg);
        dispatch({
          type: "INITALCHANNELLINEUP",
          value: {
            genreList: newGenreList.sort(), numChannels: numChannels, hdChannels: hdChannels, channels: allChannels,
            results: results, title: title, location: location, active: "alpha", loaded: true, comparePackages: comparePackages
          }
        });
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
      })
      .catch(error => {
        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        let errorMsg = `MethodName:getChannelLineupbackend,errorMessage:${error.message}`;
        logKafka("ERROR","ChannelLineUp",errorMsg,getErrorLogUrl,"applogs",visitId);
      });
  }
};

export const sortPackages = (pkgs, channels, dispatch) => {
  pkgs.sort(function(a, b) {
    let aPackages = 0;
    let bPackages = 0;
    channels.forEach(channel => {
      const channelPkgs = channel.packagelist;
      // if the packagelist contains the channel
      if (channelPkgs.includes(a.packageusoc)) {
        aPackages++;
      }
      if (channelPkgs.includes(b.packageusoc)) {
        bPackages++;
      }
    });

    if (aPackages < bPackages) {
      return 1;
    } else if (aPackages > bPackages) {
      return -1;
    } else {
      if (parseFloat(a.totalchannelcount) < parseFloat(b.totalchannelcount)) {
        return 1;
      } else {
        return -1;
      }
    }
  });

  dispatch({ type: "SETPACKAGES", value: { packageList: pkgs } });
};

export const selectPackage = (pkgsSelected, pkg, dispatch) => {
  let pkgs = [];
  if (pkgsSelected) {
    pkgs = [...pkgsSelected];
  }
  pkgs.push(pkg);
  if (pkgsSelected.length >= 2 || pkgsSelected[0] === null) {
    pkgs.shift();
  }
  dispatch({ type: "UPDATESELECTEDPKGS", value: pkgs });
};

export const deselectPackage = (pkgsSelected, pkg, dispatch) => {
  var pkgs = pkgsSelected.filter(function(value) {
    return value !== pkg;
  });

  dispatch({ type: "UPDATESELECTEDPKGS", value: pkgs });
};

export const removeChannel = (selected, toRemove, packages, dispatch) => {
  var selectedChannelPrograms = selected.filter(function(channel) {
    return channel.channelno !== toRemove;
  });
  dispatch({ type: "SETSELECTEDCHANNELPROGRAMS", value: selectedChannelPrograms });
  sortPackages(packages, selectedChannelPrograms, dispatch);
  if (selectedChannelPrograms.length === 0) {
    dispatch({ type: "CLUMESSAGE", value: "" });
    clearSelectedPkgs(dispatch);
  }
};

export const displayChannelLineup = dispatch => {
  dispatch({ type: "SETCLUDISPLAY", value: "CLU" });
};

export const displayCLUMaster = dispatch => {
  dispatch({ type: "SETCLUDISPLAY", value: "MASTER" });
};

export const clearSelectedPkgs = dispatch => {
  dispatch({ type: "UPDATESELECTEDPKGS", value: [] });
};

export const clearSearchChannelProgram = dispatch => {
  dispatch({ type: "SEARCHANNELTEXT", value: "" });
  dispatch({ type: "SETSEARCHDROPDOWN", value: { searchDropdown: [] } });
  dispatch({ type: "SETCHANNELPROGRAMRESULTS", value: { channelProgramResults: [] } });
};

export const clearSelectedChannels = dispatch => {
  dispatch({ type: "SETSELECTEDCHANNELPROGRAMS", value: [] });
};

export const clearSearchChannelLineup = (channels, dispatch) => {
  dispatch({ type: "SEARCHVALUEEMPTY", value: "" });
  filterAlpha(channels, dispatch);
};

export const clearChannelResults = dispatch => {
  dispatch({ type: "CLEARCHANNELRESULTS", value: "" });
};

export const setViewDetailId = (smodelId, dispatch) => {
  dispatch({ type: "SETDETAILMODELNONE", value: smodelId });
};

export const filterCategoryChannel = (channels, genreList, dispatch) => {
  let newChannels = channels;
  const channelHeadings = genreList;
  newChannels.sort(function(a, b) {
    if (a.genrelist < b.genrelist) {
      return -1;
    } else {
      return 1;
    }
  });
  let results = [];
  let index = 0;
  channelHeadings.forEach(function(value) {
    results.push(value);
    for (var i = index; i < newChannels.length; i++) {
      if (newChannels[i].genrelist.toUpperCase() === value.toUpperCase()) {
        results.push(newChannels[i]);
      } else {
        index = i++;
        break;
      }
    }
  });
  dispatch({ type: "CHANNELRESULTSUPDATE", value: { results: results, active: "genre" } });
};

export const searchOnChangeChannel = (newSearchValue, statechannels, dispatch) => {
  dispatch({ type: "SEARCHANNELTEXT", value: newSearchValue });

  if (newSearchValue !== "") {
    const channels = statechannels;
    if (newSearchValue[0].match(/[A-Za-z]/i)) {
      const searchValue = newSearchValue.toUpperCase();
      let results = channels.filter(channel => {
        let channelName = channel.channelname.toUpperCase();
        return channelName.startsWith(searchValue);
      });
      dispatch({ type: "CHANNELRESULTS", value: results });
    } else if (newSearchValue[0].match(/[0-9]/i)) {
      filterChannelNumber(statechannels, dispatch);
      let results = channels.filter(channel => {
        let channelNo = channel.channelno;
        return channelNo.startsWith(newSearchValue);
      });
      dispatch({ type: "CHANNELRESULTS", value: results });
    }
  } else {
    filterAlpha(statechannels, dispatch);
  }
};

export const filterAlpha = (channels, dispatch) => {
  if (channels === null) return;
  let newChannels = channels;
  const channelHeadings = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];
  newChannels.sort(function(a, b) {
    if (a.channelname.toUpperCase() < b.channelname.toUpperCase()) {
      return -1;
    } else {
      return 1;
    }
  });
  let results = [];
  let index = 0;
  channelHeadings.forEach(function(value) {
    results.push(value);
    var containsChannels = false;
    for (var i = index; i < newChannels.length; i++) {
      if (newChannels[i].channelname[0].toUpperCase() === value) {
        results.push(newChannels[i]);
        containsChannels = true;
      } else {
        index = i++;
        break;
      }
    }
    if (!containsChannels) {
      results.pop();
    }
  });
  dispatch({ type: "CHANNELRESULTSUPDATE", value: { results: results, active: "alpha" } });
};

export const filterChannelNumber = (channels, dispatch) => {
  let newChannels = channels;
  newChannels.sort(function (a, b) {
    if (Number(a.channelno) < Number(b.channelno)) {
      return -1;
    } else {
      return 1;
    }
  });
  dispatch({ type: "CHANNELRESULTSUPDATE", value: { results: newChannels, active: "num" } });
};

export const filterGainLose = (channels, dispatch) => {
  const left = channels[0].channels;
  const right = channels[1].channels;

  let lose = left.filter(channelLeft => {
    let contains = false;
    // Check if right channels has channelLeft
    right.forEach(channelRight => {
      if (channelRight.channelname === channelLeft.channelname) {
        contains = true;
      }
    });
    return !contains;
  });

  let win = right.filter(channelRight => {
    let contains = false;

    // Check if right channels has channelLeft
    left.forEach(channelLeft => {
      if (channelRight.channelname === channelLeft.channelname) {
        contains = true;
      }
    });
    return !contains;
  });

  let newChannels = [];
  if (lose.length !== 0) {
    newChannels.push("Losing");
    newChannels.push(...lose);
  }
  if (win.length !== 0) {
    newChannels.push("Getting");
    newChannels.push(...win);
  }

  dispatch({
    type: "CHANNELRESULTSUPDATE",
    value: { results: newChannels, active: "gl" }
  });
};

const getRequestChannelView = (  visitid,  visitorid,  tarcode,  zipcode,  packageid) => {
  let request = {
    visitid: visitid.toString(), visitorid: visitorid.toString(), tarcode: '',
    zipcode: zipcode.toString(), packageid: packageid.toString()
  };

  if(InHomeUtils.isNotEmpty(tarcode)){
    request.tarcode = tarcode.toString();
  }
  return JSON.stringify(request);
};

const getVhoDetails = (visitid, visitorid, tarcode, zipcode, appid) => {
  let request = { visitid: visitid, visitorid: visitorid, tarcode: tarcode, zip: zipcode, appid: appid };
  return JSON.stringify(request);
};
